import type { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";

export type ColumnDefWithPermissions<TData = Record<string, unknown>> = ColumnDef<TData> & {
  requiredPermissions?: string[];
  /** Backend OrderFilter property for server-side sorting.
   *  Maps the TanStack column id (UI identifier) to the backend sortable
   *  property. Falls back to the column id when absent. Plan §4.7.2. */
  sortField?: string;
  /** Force numeric comparison + apply .numeric-cell class. Plan §4.7.5. */
  numeric?: boolean;
};

/**
 * Hook pour filtrer les colonnes selon les permissions utilisateur
 */
export function useTableColumns<TData = Record<string, unknown>>(
  columns: ColumnDefWithPermissions<TData>[],
  can: (permission: string) => boolean,
): ColumnDefWithPermissions<TData>[] {
  return useMemo(() => {
    return columns.filter((col) => {
      if (!col.requiredPermissions) return true;
      return col.requiredPermissions.every((perm) => can(perm));
    });
  }, [columns, can]);
}
